<nes-asset
  class="nes-fixed nes-inset-0 nes-w-screen nes-bg-secondary-default nes-h-screen nes-z-0 nes-rotate-180"
  color=""
  name="flow-gradient"
  resize="nes-w-screen nes-h-screen"
>
</nes-asset>
<div class="nes-relative nes-z-10">
  <nes-text color="text-inverse-subdued">
    {{ "AANVRAGEN.TITLE_EYEBROW" | translate }}
  </nes-text>
  <nes-heading
    color="text-inverse-subdued"
    class="nes-mb-20 md:nes-px-0 nes-z-10"
    tag="h1"
    [size]="{ xs: '600', md: '1200' }"
  >
    {{ "AANVRAGEN.TITLE" | translate: { pakket: orderedProduct } }}
  </nes-heading>

  <div
    class="xl:nes-flex xl:nes-justify-between nes-w-full md:nes-6/12 md:nes-w-full"
  >
    <div
      class="wizard-container nes-bg-form nes-w-full xl:nes-w-7/12 nes-h-fit nes-p-10 nes-rounded nes-mb-20 xl:nes-mb-0"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
